export const TEXTS = {
  FULL_SCREEN: 'Full screen',
  EXIT_FULL_SCREEN: 'Exit full screen',
};
